<h1 class="title" e2eId="title">
  {{ title }}
</h1>

<h2 [class.less-margin]="hasLessMargin" class="sub-title" e2eId="sub-title">
  {{ subtitle }}
</h2>
